<template>
  <div class="radio-box" :style="{ border: mBorder }">
    <div class="discount-text" style="font-weight: 500; margin-top: 28px">{{ testCount }}</div>
    <div class="discount-text">{{ testUnitPrice }}</div>
    <div
      class="discount-text"
      style="line-height: 21px; font-size: 15px; font-weight: 600; margin-top: 15px"
    >
      {{ testDiscount }}
    </div>
    <img class="point" :src="pointSrc" />
    <div class="discount-text">{{ $t('total') }}</div>
    <div class="discount-text">{{ testTotalPrice }}</div>
  </div>
</template>

<script>
export default {
  name: 'DiscountCell',
  components: {},
  props: {
    cellData: {
      type: Object,
      default: () => {},
    },
    modelId: {
      type: Number,
      default: 0,
    },
    mIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      testCount: '',
      testUnitPrice: '',
      testDiscount: '',
      testTotalPrice: '',
      pointSrc: '@/assets/images/hsk/inactive.svg',
      mBorder: '',
    }
  },
  created() {},
  computed: {},
  watch: {
    cellData: {
      handler(newVal) {
        console.log('当前数据', newVal, this.mIndex)
        if (newVal) this.showView()
      },
      deep: true,
      immediate: true,
    },
    modelId: {
      handler(newVal) {
        this.onSelectView(newVal)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    showView() {
      let dt = this.cellData
      this.testCount = this.$i18n.tc('test_count', dt.item_count, { test_num: dt.item_count })
      this.testUnitPrice =
        dt.currency + ' ' + this.$t('unit_price', { price: dt.unit_price / dt.currency_base })
      this.testDiscount = dt.discount ? '-' + dt.discount : ''
      this.testTotalPrice = dt.currency + ' ' + dt.price / dt.currency_base
    },
    onSelectView(id) {
      if (this.mIndex == id) {
        console.log('被选中')
        this.pointSrc = require('@/assets/images/hsk/focus.svg')
        this.mBorder = '2px solid #faae56'
      } else {
        this.mBorder = '0'
        this.pointSrc = require('@/assets/images/hsk/inactive.svg')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.radio-box {
  display: flex;
  flex-direction: column;
  justify-content: none;
  align-items: center;
  background: #fafafb;
  border: 2px solid #faae56;
  color: #000000;
  width: 167px;
  height: 223px;
  border-radius: 6px;
  font-family: Proxima Nova;
  text-align: center;

  .discount-text {
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 8px;
  }

  .point {
    width: 24px;
    height: 24px;
    margin-top: 33px;
    margin-bottom: 10px;
  }
}
</style>
